"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * 判断是否HTML元素
 * @return {Boolean} 是否HTML元素
 */

var isElement = function isElement(o) {
  return o instanceof Element || o instanceof HTMLDocument;
};

exports.default = isElement;